export const API_CONFIG = {
    //baseUrl: "http://localhost:8088"
    //baseUrl: "http://192.168.171.39/confianca"
    baseUrl: "https://www.tourregular.com.br/confianca"
    //baseUrl: "https://www.tourregular.com.br/confianca1"
}